/* ===== THORNWOVEN — PRODUCT MODAL + QUICK ADD ===== */
(function () {
  'use strict';

  var modal = document.getElementById('productModal');
  var selVariantId = null;
  var curProd = null;

  function openModal(card) {
    var json = card.querySelector('.product-json');
    if (!json) return;
    var p;
    try { p = JSON.parse(json.textContent); } catch (e) { return; }
    curProd = p;
    selVariantId = null;

    var swatch = document.getElementById('modalSwatch');
    var imgs = p.images || [];
    var mainImg = imgs[0] ? '<img src="' + imgs[0] + '" alt="' + p.title + '" class="modal-photo" id="modalMainPhoto">' : '';
    var thumbs = '';
    if (imgs.length > 1) {
      thumbs = '<div class="modal-thumbs">' + imgs.map(function (src, i) {
        return '<button class="modal-thumb' + (i === 0 ? ' sel' : '') + '" data-src="' + src + '"><img src="' + src + '" alt=""></button>';
      }).join('') + '</div>';
    }
    swatch.innerHTML = mainImg + thumbs;
    swatch.querySelectorAll('.modal-thumb').forEach(function (t) {
      t.onclick = function () {
        swatch.querySelectorAll('.modal-thumb').forEach(function (x) { x.classList.remove('sel'); });
        t.classList.add('sel');
        var m = document.getElementById('modalMainPhoto');
        if (m) m.src = t.dataset.src;
      };
    });

    document.getElementById('modalType').textContent = p.type || 'Tee';
    document.getElementById('modalName').textContent = p.title;
    document.getElementById('modalPrice').textContent = p.price;
    document.getElementById('modalDesc').textContent = p.description || '';

    var sz = document.getElementById('modalSizes');
    sz.innerHTML = '';
    (p.variants || []).forEach(function (v) {
      var b = document.createElement('button');
      b.className = 'sz-btn' + (v.available ? '' : ' sz-soldout');
      b.textContent = v.title;
      if (!v.available) b.disabled = true;
      b.onclick = function () {
        sz.querySelectorAll('.sz-btn').forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        selVariantId = v.id;
      };
      sz.appendChild(b);
    });

    modal.classList.add('open');
    if (window.lockScroll) window.lockScroll();
  }

  function closeModal() {
    modal.classList.remove('open');
    if (window.unlockScroll) window.unlockScroll();
  }

  if (modal) {
    var mc = document.getElementById('modalClose');
    if (mc) mc.onclick = closeModal;
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

    var addBtn = document.getElementById('modalAddBtn');
    if (addBtn) addBtn.onclick = function () {
      if (!selVariantId) { window.showToast && window.showToast('Select a size first'); return; }
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      window.addToCartVariant(selVariantId, 1).then(function () {
        closeModal();
        window.showToast && window.showToast('Added — ' + curProd.title + ' ✦');
      }).catch(function (err) {
        window.showToast && window.showToast(err.message || 'Could not add to bag');
      }).then(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
      });
    };
  }

  // Card clicks → open modal (ignore clicks on links)
  document.querySelectorAll('.product-card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      openModal(card);
    });
  });

  // ── Size Guide ──
  window.openSizeGuide = function () {
    var o = document.getElementById('sizeGuideOverlay');
    if (o) o.classList.add('open');
    if (window.lockScroll) window.lockScroll();
  };
  window.closeSizeGuide = function () {
    var o = document.getElementById('sizeGuideOverlay');
    if (o) o.classList.remove('open');
    if (modal && !modal.classList.contains('open') && window.unlockScroll) window.unlockScroll();
  };
  var sgOverlay = document.getElementById('sizeGuideOverlay');
  if (sgOverlay) sgOverlay.addEventListener('click', function (e) {
    if (e.target === sgOverlay) window.closeSizeGuide();
  });
  window.switchSizeTab = function (tab, btn) {
    var tees = document.getElementById('sgTees');
    var hoodies = document.getElementById('sgHoodies');
    if (tees) tees.style.display = tab === 'tees' ? 'block' : 'none';
    if (hoodies) hoodies.style.display = tab === 'hoodies' ? 'block' : 'none';
    document.querySelectorAll('.sg-tab').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  // ── Product PAGE gallery: thumbnails swap the main image ──
  var pdpMain = document.getElementById('pdpMainImage');
  var pdpThumbs = document.querySelectorAll('.pdp-thumb');
  if (pdpMain && pdpThumbs.length) {
    pdpThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        pdpThumbs.forEach(function (x) { x.classList.remove('sel'); });
        t.classList.add('sel');
        if (t.dataset.src) pdpMain.src = t.dataset.src;
      });
    });
  }

  // ── Product PAGE add-to-cart ──
  var productSizes = document.getElementById('productSizes');
  if (productSizes) {
    var hidden = document.getElementById('selectedVariantId');
    var hasSelection = false;
    productSizes.querySelectorAll('.sz-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        productSizes.querySelectorAll('.sz-btn').forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        hasSelection = true;
        if (hidden && b.dataset.variantId) hidden.value = b.dataset.variantId;
      });
    });
    function doAdd(btn, restoreLabel) {
      if (!hasSelection) {
        window.showToast && window.showToast('Select a size first');
        productSizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Adding...';
      window.addToCartVariant(hidden.value, 1).then(function () {
        window.showToast && window.showToast('Added to bag ✦');
      }).catch(function (err) {
        window.showToast && window.showToast(err.message || 'Could not add');
      }).then(function () {
        btn.disabled = false;
        btn.textContent = restoreLabel;
      });
    }

    var form = document.getElementById('productForm');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      doAdd(document.getElementById('productAddBtn'), 'Add to Bag');
    });

    // ── Sticky mobile add-to-bag ──
    var stickyAtc = document.getElementById('stickyAtc');
    var stickyBtn = document.getElementById('stickyAtcBtn');
    var mainAddBtn = document.getElementById('productAddBtn');
    if (stickyAtc && mainAddBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // Show the sticky bar once the main button scrolls out of view
          if (en.isIntersecting) stickyAtc.classList.remove('visible');
          else stickyAtc.classList.add('visible');
        });
      }, { threshold: 0 });
      io.observe(mainAddBtn);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      doAdd(stickyBtn, 'Add to Bag');
    });
  }

  window.openModal = openModal;
  window.closeModal = closeModal;
})();
